import { CreditCard } from 'lucide-react';
import { lazy } from 'react';

import { label, type FeatureModule } from '@/platform/app/contracts';

import { billingSlice } from './domain/state/billingSlice';

const BillingPage = lazy(() =>
  import('./presentation/pages/BillingPage').then((m) => ({ default: m.BillingPage })),
);

/** SaaS subscription: plans, checkout, invoices (settings section). */
export const billingModule: FeatureModule = {
  id: 'billing',
  settingsSections: [
    {
      id: 'billing',
      group: 'organization',
      order: 10,
      label: label('settings', 'nav_billing'),
      icon: CreditCard,
      Component: BillingPage,
      wrapInSection: true,
    },
  ],
  slices: [billingSlice],
};
